import { createContext } from 'react';

export interface TicketMaskStateContextValue {
  showSolution: boolean;
  setShowSolution: (value: boolean) => void;
}

export const TicketMaskStateContext =
  createContext<TicketMaskStateContextValue>(null);
